"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.run = void 0;
const core = __importStar(require("@actions/core"));
const github = __importStar(require("@actions/github"));
const service = __importStar(require("./service"));
const rtd_1 = __importDefault(require("./rtd"));
async function run(getInput, activateProject, deactivateProject) {
    const rtdToken = getInput("rtd-token", { required: true });
    const project = getInput("rtd-project", { required: true });
    const githubToken = getInput("github-token", { required: true });
    const rtd = new rtd_1.default(rtdToken);
    // Check if head repo is same with base repo
    const context = github.context;
    if (context.eventName !== "pull_request" &&
        context.eventName !== "pull_request_target") {
        core.warning(`This Action does not support the given event ${context.eventName}.`);
        return;
    }
    const head = context.payload.pull_request?.head;
    if (head.repo === null) {
        core.info("HEAD branch not found.");
    }
    else if (context.payload.pull_request?.base.repo.full_name !== head.repo.full_name) {
        core.warning("PR made from another Git repo is not supported.");
        return;
    }
    core.debug(`The payload is ${JSON.stringify(context.payload)}`);
    const branch = head.ref;
    const translates = await rtd.getTranslates(project);
    if (context.payload.action === "closed") {
        if (!branch) {
            core.warning("HEAD branch not found, impossible to specify which RTD build should be disabled.");
            return;
        }
        await deactivateProject(translates, rtd, branch, githubToken, project);
        return;
    }
    else if (context.payload.pull_request?.state === "closed") {
        core.info("The target pull request is already closed, no reaction needed.");
        return;
    }
    await activateProject(translates, rtd, branch, githubToken, project);
}
exports.run = run;
if (require.main === module) {
    run(core.getInput, service.activateProject, service.deactivateProject);
}
else {
    // https://nodejs.org/api/modules.html#modules_accessing_the_main_module
    core.info("the script is loaded as a module, so skipping the execution");
}
